import { satisfiesExpected } from "./conditions";
import { getAnswerById } from "./helpers";

export function getVisibleQuestions(questions, answers) {
    const visible = [];

    for (let i = 0; i < questions.length; i++) {
        const q = questions[i];

        // Never show hidden/system questions
        if (q.hidden === true || q.type === "system") continue;

        // Optional predicate for complex logic
        if (typeof q.conditionalFn === "function") {
            const ok = q.conditionalFn({ answers, questions, getAnswerById });
            if (!ok) continue;
        }

        // Always show if not conditional
        if (!q.conditional) {
            visible.push(q);
            continue;
        }

        // Conditional with dependsOn/dependsOnValue
        if (q.dependsOn && q.dependsOnValue) {
            let ok = true;

            const deps = Array.isArray(q.dependsOn) ? q.dependsOn : [q.dependsOn];
            const expectedValues = Array.isArray(q.dependsOnValue)
                ? q.dependsOnValue
                : [q.dependsOnValue];

            for (let j = 0; j < deps.length; j++) {
                const depId = deps[j];
                const expected = expectedValues[Math.min(j, expectedValues.length - 1)];
                const depIndex = questions.findIndex((qq) => qq.id === depId);
                if (depIndex === -1) {
                    ok = false;
                    break;
                }
                const depAns = answers[depIndex];
                if (!satisfiesExpected(depAns, expected)) {
                    ok = false;
                    break;
                }
            }

            if (ok) visible.push(q);
        } else {
            // conditional true but no dependsOn—show because conditionalFn already passed (if any)
            visible.push(q);
        }
    }

    return visible;
}
